import { useState,useEffect } from 'react';
import { Box, Card, Checkbox, Grid, Typography } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedOutlinedIcon from '@mui/icons-material/RadioButtonUncheckedOutlined';
import SpeedIcon from '@mui/icons-material/Speed';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
const CardItemServicios = ({
    item,
    servicioSelect,
    setServicioSelect,
    coberturaMaxima,
    permisoEsp,
    disabledPrefa = false,
    permisoPrefa
}) => {
    const [mbBajada, setmbBajada] = useState(0)
    const [precio, setPrecio] = useState(0)
    useEffect(() => {
        const splite = item?.bajada?.split('.')
        if(splite?.length > 0){
            setmbBajada(splite[0])
        }
    }, [item])
    const onClickCard = () =>{
        if(coberturaMaxima >= mbBajada || permisoEsp){
            setServicioSelect({...item,prefactibilidad: 'POSITIVA'})
        }else if(!disabledPrefa && permisoPrefa){
            if(item?.tipo?.trim() === 'PY'){
                setServicioSelect({...item, prefactibilidad: 'NEGATIVA'})
            }
        }
    }
    useEffect(() => {
        if(item?.precio){
            const numero = Number(item?.precio)
            if(!isNaN(numero)){
                setPrecio(Math.round(numero * 100) / 100);
            }
        }
    }, [item])

    return (
        <Card
            sx={{
                background: servicioSelect?.cod_producto === item?.cod_producto
                    ? item?.tipo_descripcion === 'NUBI PyMES'
                        ? 'linear-gradient(135deg, #ff9f43 0%, #ff8008 100%)'
                        : 'linear-gradient(135deg, #1e88e5 0%, #1565c0 100%)'
                    : (coberturaMaxima >= mbBajada || permisoEsp || (!disabledPrefa && permisoPrefa && item?.tipo?.trim() === 'PY'))
                        ? item?.tipo_descripcion === 'NUBI PyMES'
                            ? 'linear-gradient(135deg, #fff8f0 0%, #fff5e8 100%)'
                            : 'linear-gradient(135deg, #fafbfd 0%, #f5f8fc 100%)'
                        : 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                border: servicioSelect?.cod_producto === item?.cod_producto 
                    ? item?.tipo_descripcion === 'NUBI PyMES'
                        ? '2px solid #ffb84d'
                        : '2px solid #42a5f5'
                    : (coberturaMaxima >= mbBajada || permisoEsp || (!disabledPrefa && permisoPrefa && item?.tipo?.trim() === 'PY'))
                        ? item?.tipo_descripcion === 'NUBI PyMES'
                            ? '2px solid #ffe4c4'
                            : '2px solid #dce8f5'
                        : '2px solid #dee2e6',
                borderRadius: '16px',
                boxShadow: servicioSelect?.cod_producto === item?.cod_producto
                    ? item?.tipo_descripcion === 'NUBI PyMES'
                        ? '0 8px 24px rgba(255, 159, 67, 0.25), 0 0 0 1px rgba(255, 184, 77, 0.1) inset'
                        : '0 8px 24px rgba(30, 136, 229, 0.25), 0 0 0 1px rgba(66, 165, 245, 0.1) inset'
                    : (coberturaMaxima >= mbBajada || permisoEsp || (!disabledPrefa && permisoPrefa && item?.tipo?.trim() === 'PY'))
                        ? item?.tipo_descripcion === 'NUBI PyMES'
                            ? '0 2px 10px rgba(255, 159, 67, 0.08)'
                            : '0 2px 10px rgba(100, 150, 200, 0.08)'
                        : '0 2px 8px rgba(0,0,0,0.06)',
                mt: 1.5,
                transition: 'all 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
                cursor: (coberturaMaxima >= mbBajada || permisoEsp || (!disabledPrefa && permisoPrefa && item?.tipo?.trim() === 'PY')) 
                    ? 'pointer' 
                    : 'not-allowed',
                '&:hover':{
                    transform: (coberturaMaxima >= mbBajada || permisoEsp || (!disabledPrefa && permisoPrefa && item?.tipo?.trim() === 'PY'))
                        ? 'translateY(-4px)'
                        : 'none',
                    boxShadow: servicioSelect?.cod_producto === item?.cod_producto
                        ? item?.tipo_descripcion === 'NUBI PyMES'
                            ? '0 12px 32px rgba(255, 159, 67, 0.35), 0 0 0 1px rgba(255, 184, 77, 0.2) inset'
                            : '0 12px 32px rgba(30, 136, 229, 0.35), 0 0 0 1px rgba(66, 165, 245, 0.2) inset'
                        : (coberturaMaxima >= mbBajada || permisoEsp || (!disabledPrefa && permisoPrefa && item?.tipo?.trim() === 'PY'))
                            ? item?.tipo_descripcion === 'NUBI PyMES'
                                ? '0 4px 18px rgba(255, 159, 67, 0.12), 0 0 0 2px #ffdbb8'
                                : '0 4px 18px rgba(100, 150, 200, 0.12), 0 0 0 2px #d4e4f7'
                            : '0 2px 8px rgba(0,0,0,0.06)'
                },
                position: 'relative',
                overflow: 'hidden'
            }}
            onClick={()=>onClickCard()}
        >
            {/* Indicador de selección - Barra superior con brillo */}
            {servicioSelect?.cod_producto === item?.cod_producto && (
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        height: '5px',
                        background: item?.tipo_descripcion === 'NUBI PyMES'
                            ? 'linear-gradient(90deg, #ffb84d 0%, #ffc870 50%, #ffb84d 100%)'
                            : 'linear-gradient(90deg, #42a5f5 0%, #64b5f6 50%, #42a5f5 100%)',
                        backgroundSize: '200% 100%',
                        animation: 'shimmer 2s ease-in-out infinite',
                        zIndex: 1,
                        '@keyframes shimmer': {
                            '0%': { backgroundPosition: '-200% 0' },
                            '100%': { backgroundPosition: '200% 0' }
                        }
                    }}
                />
            )}

            {/* Badge de Deshabilitado Mejorado */}
            {!(coberturaMaxima >= mbBajada || permisoEsp || (servicioSelect?.cod_producto === item?.cod_producto && servicioSelect?.prefactibilidad === 'NEGATIVA')) && (
                <Box
                    sx={{
                        position: 'absolute',
                        top: 14,
                        right: 14,
                        px: 2,
                        py: 0.75,
                        background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%)',
                        borderRadius: '20px',
                        boxShadow: '0 4px 12px rgba(255, 107, 107, 0.4)',
                        zIndex: 2,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.5
                    }}
                >
                    <Box
                        sx={{
                            width: 6,
                            height: 6,
                            borderRadius: '50%',
                            backgroundColor: '#fff',
                            animation: 'pulse 2s ease-in-out infinite',
                            '@keyframes pulse': {
                                '0%, 100%': { opacity: 1 },
                                '50%': { opacity: 0.4 }
                            }
                        }}
                    />
                    <Typography
                        sx={{
                            color: '#fff',
                            fontSize: 10,
                            fontWeight: 700,
                            textTransform: 'uppercase',
                            letterSpacing: '0.8px'
                        }}
                    >
                        Sin Cobertura
                    </Typography>
                </Box>
            )}

            <Grid container spacing={1.5} sx={{p: {xs: 1.5, sm: 2}}}>
                {/* Checkbox */}
                <Grid item xs={2} sm={1.5} md={1} display='flex' justifyContent='center' alignItems='center'>
                    <Checkbox
                        checked={servicioSelect?.cod_producto === item?.cod_producto}
                        icon={
                            <Box
                                sx={{
                                    width: 28,
                                    height: 28,
                                    border: item?.tipo_descripcion === 'NUBI PyMES'
                                        ? '3px solid #ffdbb8'
                                        : '3px solid #d4e4f7',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                    backgroundColor: item?.tipo_descripcion === 'NUBI PyMES'
                                        ? '#fff8f0'
                                        : '#f0f6fc',
                                    '&:hover': {
                                        borderColor: item?.tipo_descripcion === 'NUBI PyMES'
                                            ? '#ffb84d'
                                            : '#64b5f6',
                                        backgroundColor: item?.tipo_descripcion === 'NUBI PyMES'
                                            ? 'rgba(255, 184, 77, 0.12)'
                                            : 'rgba(100, 181, 246, 0.12)',
                                        transform: 'scale(1.1)'
                                    }
                                }}
                            >
                                <RadioButtonUncheckedOutlinedIcon sx={{fontSize: 0}} />
                            </Box>
                        }
                        checkedIcon={
                            <Box
                                sx={{
                                    width: 28,
                                    height: 28,
                                    background: item?.tipo_descripcion === 'NUBI PyMES'
                                        ? 'linear-gradient(135deg, #ff9f43 0%, #ffb84d 100%)'
                                        : 'linear-gradient(135deg, #1e88e5 0%, #42a5f5 100%)',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    boxShadow: item?.tipo_descripcion === 'NUBI PyMES'
                                        ? '0 4px 12px rgba(255, 159, 67, 0.5), 0 0 0 3px rgba(255, 184, 77, 0.2)'
                                        : '0 4px 12px rgba(30, 136, 229, 0.5), 0 0 0 3px rgba(66, 165, 245, 0.2)',
                                    animation: 'checkPulse 0.5s cubic-bezier(0.4, 0, 0.2, 1)'
                                }}
                            >
                                <CheckCircleIcon sx={{color: '#fff', fontSize: 20}} />
                            </Box>
                        }
                        sx={{
                            p: 0,
                            '&:hover': {
                                backgroundColor: 'transparent'
                            }
                        }}
                    />
                </Grid>

                {/* Contenido Principal */}
                <Grid item xs={10} sm={6.5} md={7}>
                    <Box display='flex' flexDirection='column' gap={0.4}>
                        {/* Tipo/Categoría con Icono y Badge */}
                        <Box display='flex' alignItems='center' gap={0.8}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: 24,
                                    height: 24,
                                    borderRadius: '8px',
                                    background: servicioSelect?.cod_producto === item?.cod_producto
                                        ? 'rgba(255, 255, 255, 0.25)'
                                        : (coberturaMaxima >= mbBajada || permisoEsp || (!disabledPrefa && permisoPrefa && item?.tipo?.trim() === 'PY'))
                                            ? item?.tipo_descripcion === 'NUBI PyMES'
                                                ? 'linear-gradient(135deg, #fff5e8 0%, #ffeccc 100%)'
                                                : 'linear-gradient(135deg, #e8f2fa 0%, #d9e9f7 100%)'
                                            : 'rgba(158, 158, 158, 0.15)'
                                }}
                            >
                                <SignalCellularAltIcon 
                                    sx={{
                                        fontSize: 14,
                                        color: servicioSelect?.cod_producto === item?.cod_producto
                                            ? '#fff'
                                            : (coberturaMaxima >= mbBajada || permisoEsp || (!disabledPrefa && permisoPrefa && item?.tipo?.trim() === 'PY'))
                                                ? item?.tipo_descripcion === 'NUBI PyMES'
                                                    ? '#d4940f'
                                                    : '#5b8fc4'
                                                : '#9e9e9e'
                                    }}
                                />
                            </Box>
                            <Typography 
                                sx={{
                                    color: servicioSelect?.cod_producto === item?.cod_producto
                                        ? 'rgba(255, 255, 255, 0.95)'
                                        : (coberturaMaxima >= mbBajada || permisoEsp || (!disabledPrefa && permisoPrefa && item?.tipo?.trim() === 'PY'))
                                            ? item?.tipo_descripcion === 'NUBI PyMES'
                                                ? '#d4940f'
                                                : '#6b95c1'
                                            : '#9e9e9e',
                                    fontSize: {xs: 11, sm: 12},
                                    fontWeight: 700,
                                    letterSpacing: '1px',
                                    textTransform: 'uppercase'
                                }} 
                                variant='caption'
                            >
                                {item?.tipo_descripcion}
                            </Typography>
                        </Box>

                        {/* Nombre del servicio */}
                        <Typography 
                            sx={{
                                color: servicioSelect?.cod_producto === item?.cod_producto
                                    ? '#fff'
                                    : (coberturaMaxima >= mbBajada || permisoEsp || (!disabledPrefa && permisoPrefa && item?.tipo?.trim() === 'PY'))
                                        ? '#202124'
                                        : '#757575',
                                fontWeight: 700,
                                fontSize: {xs: 15, sm: 17, md: 18},
                                lineHeight: 1.3
                            }} 
                            variant='h4'
                        >
                            {item?.nombre}
                        </Typography>

                        {/* Alerta Sin Cobertura */}
                        {servicioSelect?.cod_producto === item?.cod_producto && servicioSelect?.prefactibilidad === 'NEGATIVA' && (
                            <Box
                                sx={{
                                    mt: 0.8,
                                    p: 1,
                                    backgroundColor: '#fff5f5',
                                    border: '1px solid #feb2b2',
                                    borderRadius: '8px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 0.3
                                }}
                            >
                                <Box display='flex' alignItems='center' gap={0.5}>
                                    <Box
                                        sx={{
                                            width: 16,
                                            height: 16,
                                            borderRadius: '50%',
                                            backgroundColor: '#fc8181',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#fff',
                                            fontSize: 10,
                                            fontWeight: 700
                                        }}
                                    >
                                        !
                                    </Box>
                                    <Typography 
                                        sx={{
                                            color: '#c53030',
                                            fontWeight: 700,
                                            fontSize: {xs: 10, sm: 11}
                                        }}
                                    >
                                        SIN COBERTURA
                                    </Typography>
                                </Box>
                                <Typography 
                                    sx={{
                                        color: '#742a2a',
                                        fontSize: {xs: 9, sm: 10},
                                        lineHeight: 1.4,
                                        ml: 2.5
                                    }}
                                >
                                    Se solicitará un estudio de prefactibilidad en RF y FO.
                                </Typography>
                            </Box>
                        )}
                    </Box>
                </Grid>

                {/* Velocidad y Precio */}
                <Grid 
                    item 
                    xs={12} 
                    sm={4} 
                    md={4} 
                    display='flex' 
                    justifyContent={{xs: 'space-between', sm: 'flex-end'}} 
                    alignItems='center' 
                    gap={1.5}
                >
                    {/* Velocidad con Icono - Diseño Mejorado */}
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            p: {xs: 1.5, sm: 2},
                            background: servicioSelect?.cod_producto === item?.cod_producto
                                ? 'rgba(255, 255, 255, 0.15)'
                                : (coberturaMaxima >= mbBajada || permisoEsp || (!disabledPrefa && permisoPrefa && item?.tipo?.trim() === 'PY'))
                                    ? item?.tipo_descripcion === 'NUBI PyMES'
                                        ? 'linear-gradient(135deg, #fff8f0 0%, #fff0db 100%)'
                                        : 'linear-gradient(135deg, #f0f6fc 0%, #e8f1fb 100%)'
                                    : 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)',
                            borderRadius: '14px',
                            minWidth: {xs: 85, sm: 95},
                            border: servicioSelect?.cod_producto === item?.cod_producto
                                ? '2px solid rgba(255, 255, 255, 0.3)'
                                : (coberturaMaxima >= mbBajada || permisoEsp || (!disabledPrefa && permisoPrefa && item?.tipo?.trim() === 'PY'))
                                    ? item?.tipo_descripcion === 'NUBI PyMES'
                                        ? '2px solid #ffdbb8'
                                        : '2px solid #d4e4f7'
                                    : '2px solid #e9ecef',
                            position: 'relative',
                            overflow: 'hidden',
                            boxShadow: servicioSelect?.cod_producto === item?.cod_producto
                                ? '0 4px 12px rgba(255, 255, 255, 0.1)'
                                : (coberturaMaxima >= mbBajada || permisoEsp || (!disabledPrefa && permisoPrefa && item?.tipo?.trim() === 'PY'))
                                    ? item?.tipo_descripcion === 'NUBI PyMES'
                                        ? '0 2px 8px rgba(255, 159, 67, 0.06)'
                                        : '0 2px 8px rgba(100, 150, 200, 0.06)'
                                    : 'none'
                        }}
                    >
                        {/* Icono de fondo decorativo con efecto de brillo */}
                        <SpeedIcon 
                            sx={{
                                position: 'absolute',
                                top: -12,
                                right: -12,
                                fontSize: 60,
                                color: servicioSelect?.cod_producto === item?.cod_producto
                                    ? 'rgba(255, 255, 255, 0.12)'
                                    : (coberturaMaxima >= mbBajada || permisoEsp || (!disabledPrefa && permisoPrefa && item?.tipo?.trim() === 'PY'))
                                        ? item?.tipo_descripcion === 'NUBI PyMES'
                                            ? 'rgba(255, 159, 67, 0.08)'
                                            : 'rgba(100, 150, 200, 0.08)'
                                        : 'rgba(158, 158, 158, 0.05)',
                                transform: 'rotate(15deg)',
                                transition: 'all 0.3s ease'
                            }}
                        />
                        <Box display='flex' alignItems='center' gap={0.5} sx={{mb: 0.3, position: 'relative', zIndex: 1}}>
                            <SpeedIcon 
                                sx={{
                                    fontSize: 14,
                                    color: servicioSelect?.cod_producto === item?.cod_producto
                                        ? 'rgba(255, 255, 255, 0.75)'
                                        : (coberturaMaxima >= mbBajada || permisoEsp || (!disabledPrefa && permisoPrefa && item?.tipo?.trim() === 'PY'))
                                            ? item?.tipo_descripcion === 'NUBI PyMES'
                                                ? '#d4940f'
                                                : '#6b95c1'
                                            : '#bdbdbd'
                                }}
                            />
                            <Typography 
                                sx={{
                                    color: servicioSelect?.cod_producto === item?.cod_producto
                                        ? 'rgba(255, 255, 255, 0.75)'
                                        : (coberturaMaxima >= mbBajada || permisoEsp || (!disabledPrefa && permisoPrefa && item?.tipo?.trim() === 'PY'))
                                            ? item?.tipo_descripcion === 'NUBI PyMES'
                                                ? '#d9a430'
                                                : '#7b9cb8'
                                            : '#9e9e9e',
                                    fontSize: {xs: 9, sm: 10},
                                    fontWeight: 600,
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.8px'
                                }}
                            >
                                Velocidad
                            </Typography>
                        </Box>
                        <Box display='flex' alignItems='baseline' gap={0.4} sx={{position: 'relative', zIndex: 1}}>
                            <Typography 
                                sx={{
                                    color: servicioSelect?.cod_producto === item?.cod_producto
                                        ? '#fff'
                                        : (coberturaMaxima >= mbBajada || permisoEsp || (!disabledPrefa && permisoPrefa && item?.tipo?.trim() === 'PY'))
                                            ? '#202124'
                                            : '#9e9e9e',
                                    fontWeight: 800,
                                    fontSize: {xs: 26, sm: 27, md: 29},
                                    lineHeight: 1
                                }}
                            >
                                {mbBajada}
                            </Typography>
                            <Typography 
                                sx={{
                                    fontSize: {xs: 12, sm: 13},
                                    fontWeight: 600,
                                    color: servicioSelect?.cod_producto === item?.cod_producto
                                        ? 'rgba(255, 255, 255, 0.85)'
                                        : (coberturaMaxima >= mbBajada || permisoEsp || (!disabledPrefa && permisoPrefa && item?.tipo?.trim() === 'PY'))
                                            ? item?.tipo_descripcion === 'NUBI PyMES'
                                                ? '#e0b054'
                                                : '#8ba8c5'
                                            : '#bdbdbd',
                                    mb: 0.3
                                }}
                            >
                                {item?.unidad_bajada}
                            </Typography>
                        </Box>
                    </Box>

                    {/* Precio con Icono - Diseño Premium */}
                    {precio > 0 && (
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                p: {xs: 1.5, sm: 2},
                                background: servicioSelect?.cod_producto === item?.cod_producto
                                    ? item?.tipo_descripcion === 'NUBI PyMES'
                                        ? 'linear-gradient(135deg, #ffb84d 0%, #ffb84d 50%, #ffb84d 100%)'
                                        : 'linear-gradient(135deg, #42a5f5 0%, #64b5f6 50%, #42a5f5 100%)'
                                    : (coberturaMaxima >= mbBajada || permisoEsp || (!disabledPrefa && permisoPrefa && item?.tipo?.trim() === 'PY'))
                                        ? item?.tipo_descripcion === 'NUBI PyMES'
                                            ? 'linear-gradient(135deg, #ff9f43 0%, #ff8008 100%)'
                                            : 'linear-gradient(135deg, #1e88e5 0%, #1976d2 100%)'
                                        : 'linear-gradient(135deg, #ced4da 0%, #adb5bd 100%)',
                                borderRadius: '14px',
                                boxShadow: servicioSelect?.cod_producto === item?.cod_producto
                                    ? item?.tipo_descripcion === 'NUBI PyMES'
                                        ? '0 6px 20px rgba(255, 184, 77, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.2) inset'
                                        : '0 6px 20px rgba(66, 165, 245, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.2) inset'
                                    : (coberturaMaxima >= mbBajada || permisoEsp || (!disabledPrefa && permisoPrefa && item?.tipo?.trim() === 'PY'))
                                        ? item?.tipo_descripcion === 'NUBI PyMES'
                                            ? '0 4px 16px rgba(255, 159, 67, 0.35)'
                                            : '0 4px 16px rgba(30, 136, 229, 0.35)'
                                        : '0 2px 8px rgba(173, 181, 189, 0.3)',
                                minWidth: {xs: 85, sm: 95},
                                position: 'relative',
                                overflow: 'hidden',
                                backgroundSize: servicioSelect?.cod_producto === item?.cod_producto ? '200% 100%' : '100% 100%',
                                animation: servicioSelect?.cod_producto === item?.cod_producto ? 'gradientShift 3s ease infinite' : 'none',
                                '@keyframes gradientShift': {
                                    '0%, 100%': { backgroundPosition: '0% 50%' },
                                    '50%': { backgroundPosition: '100% 50%' }
                                }
                            }}
                        >
                            {/* Icono de fondo decorativo mejorado */}
                            <AttachMoneyIcon 
                                sx={{
                                    position: 'absolute',
                                    top: -10,
                                    right: -10,
                                    fontSize: 60,
                                    color: 'rgba(255, 255, 255, 0.12)',
                                    transform: 'rotate(-15deg)',
                                    transition: 'all 0.3s ease'
                                }}
                            />
                            <Box display='flex' alignItems='center' gap={0.5} sx={{mb: 0.2, position: 'relative', zIndex: 1}}>
                                <AttachMoneyIcon 
                                    sx={{
                                        fontSize: 14,
                                        color: 'rgba(255, 255, 255, 0.9)'
                                    }}
                                />
                                <Typography 
                                    sx={{
                                        color: 'rgba(255, 255, 255, 0.9)',
                                        fontSize: {xs: 9, sm: 10},
                                        fontWeight: 600,
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.8px'
                                    }}
                                >
                                    Precio
                                </Typography>
                            </Box>
                            <Box display='flex' alignItems='baseline' gap={0.3} sx={{position: 'relative', zIndex: 1}}>
                                <Typography 
                                    sx={{
                                        color: '#fff',
                                        fontSize: {xs: 11, sm: 12},
                                        fontWeight: 700,
                                        mb: 0.4
                                    }}
                                >
                                    $
                                </Typography>
                                <Typography 
                                    sx={{
                                        color: '#fff',
                                        fontWeight: 800,
                                        fontSize: {xs: 22, sm: 25, md: 27},
                                        lineHeight: 1
                                    }}
                                >
                                    {precio}
                                </Typography>
                            </Box>
                            <Typography 
                                sx={{
                                    color: 'rgba(255, 255, 255, 0.85)',
                                    fontSize: {xs: 9, sm: 10},
                                    fontWeight: 500,
                                    position: 'relative',
                                    zIndex: 1
                                }}
                            >
                                /mes
                            </Typography>
                        </Box>
                    )}
                </Grid>
            </Grid>

            {/* Animación CSS */}
            <style>
                {`
                    @keyframes checkPulse {
                        0% { transform: scale(0.8); }
                        50% { transform: scale(1.1); }
                        100% { transform: scale(1); }
                    }
                `}
            </style>
        </Card>
    )
}

export default CardItemServicios